import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Shield, Lock, Database, FileText } from 'lucide-react';

const Legal = () => {
  return (
    <div className="min-h-screen bg-white text-neutral-900">
      <Navbar onSignIn={() => {}} onSignUp={() => {}} />

      <section className="mx-auto max-w-3xl px-6 pb-20 pt-16">
        <div className="mb-10 text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-3 py-1 text-xs text-neutral-600 shadow-sm">
            <Shield className="h-3.5 w-3.5" />
            <span>Legal, Privacy & GDPR</span>
          </div>
          <h1 className="font-serif text-5xl leading-[1.05] tracking-tight">
            Legal <span className="italic text-neutral-500">notices</span>
          </h1>
          <p className="mt-3 text-neutral-600">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="space-y-10 text-[15px] leading-relaxed text-neutral-700">
          <section>
            <h2 className="mb-3 flex items-center gap-2 font-serif text-2xl text-neutral-900">
              <FileText className="h-5 w-5" /> Terms of Service
            </h2>
            <p>
              By using AMAIA.CLOUD (“the Service”), you agree to these Terms. The Service provides access to AI-powered workers and automation tooling. You are responsible for the content and instructions you submit to AI workers, and for verifying outputs before acting on them. AI outputs may contain errors and should not be treated as professional advice. Availability is provided on a best-effort basis without any express warranty.
            </p>
          </section>

          <section>
            <h2 className="mb-3 flex items-center gap-2 font-serif text-2xl text-neutral-900">
              <Lock className="h-5 w-5" /> Privacy Policy
            </h2>
            <p>
              We collect only the data necessary to operate the Service: account information you provide, prompts you submit, resulting AI outputs, and technical logs. We do not sell personal data. Payment information is processed by Stripe under their own privacy policy — we never store card numbers on our servers. Cookies are used for session management and, with your consent, analytics.
            </p>
          </section>

          <section>
            <h2 className="mb-3 flex items-center gap-2 font-serif text-2xl text-neutral-900">
              <Database className="h-5 w-5" /> GDPR Rights
            </h2>
            <p>Under the General Data Protection Regulation (EU 2016/679), you have the right to:</p>
            <ul className="mt-3 list-disc space-y-1 pl-6">
              <li>Access the personal data we hold about you (Art. 15)</li>
              <li>Request rectification of inaccurate data (Art. 16)</li>
              <li>Request erasure of your data — “right to be forgotten” (Art. 17)</li>
              <li>Restrict or object to processing (Art. 18 & 21)</li>
              <li>Portability of your data in a structured, machine-readable format (Art. 20)</li>
              <li>Withdraw consent at any time without affecting prior lawful processing</li>
              <li>Lodge a complaint with a supervisory authority (e.g. CNIL in France)</li>
            </ul>
            <p className="mt-3">
              To exercise any of these rights, contact us at <a className="underline underline-offset-2" href="mailto:privacy@amaia.cloud">privacy@amaia.cloud</a>. We respond within 30 days.
            </p>
          </section>

          <section>
            <h2 className="mb-3 flex items-center gap-2 font-serif text-2xl text-neutral-900">
              <Shield className="h-5 w-5" /> Data Security & Hosting
            </h2>
            <p>
              Data is encrypted in transit (TLS 1.2+) and at rest (AES-256). Our infrastructure runs on European sovereign cloud providers. We do not use your data to train third-party AI models. LLM providers (OpenAI, Anthropic, Google) are configured with “no-training” data processing agreements where available.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-serif text-2xl text-neutral-900">AI-Generated Content Disclaimer</h2>
            <p>
              Outputs from AI workers are generated by machine-learning models and may be inaccurate, incomplete, or biased. AMAIA.CLOUD is not liable for decisions made based solely on AI outputs. You remain responsible for the ultimate use of any content produced through the Service.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-serif text-2xl text-neutral-900">Contact & Publisher</h2>
            <p>
              AMAIA.CLOUD — Augmented Mankind Abilities powered by AI.<br />
              For legal inquiries: <a className="underline underline-offset-2" href="mailto:legal@amaia.cloud">legal@amaia.cloud</a>.<br />
              Data protection: <a className="underline underline-offset-2" href="mailto:privacy@amaia.cloud">privacy@amaia.cloud</a>.
            </p>
          </section>

          <div className="pt-6 text-center text-sm text-neutral-500">
            <Link to="/" className="underline underline-offset-2 hover:text-neutral-900">Back to home</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Legal;
